"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderGridItem = exports.getAllProductsData = exports.getCollectionCache = undefined;

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _localforage = require("localforage");

var _localforage2 = _interopRequireDefault(_localforage);

var _jsCookie = require("js-cookie");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _Helpers = require("common/Helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if there is a cache for the current collection
 *
 * @return {Promise}: a promise containing an array of all product data
 */
var getCollectionCache = exports.getCollectionCache = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var activeProductCache, productCache, productDataIsCurrent, products;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            activeProductCache = "_bva_products_active_" + window.bvaccel.collection.handle;
            productCache = "_bva_products_" + window.bvaccel.collection.handle;


            _localforage2.default.config();
            productDataIsCurrent = _jsCookie2.default.get(activeProductCache) || false;
            _context.next = 6;
            return getLocalForageValue(productCache);

          case 6:
            products = _context.sent;
            return _context.abrupt("return", products ? products : false);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getCollectionCache() {
    return _ref.apply(this, arguments);
  };
}();

var getAllProductsData = exports.getAllProductsData = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(state) {
    var activeProductCache, productCache, products, _ref3, _ref3$requestLimit, requestLimit, allProductCount, pageCount, ajaxUrls;

    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(window.bvaccel.collection.handle === false)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            activeProductCache = "_bva_products_active_" + window.bvaccel.collection.handle;
            productCache = "_bva_products_" + window.bvaccel.collection.handle;
            _context2.next = 6;
            return getCollectionCache();

          case 6:
            products = _context2.sent;

            if (!products) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", products);

          case 9:
            _ref3 = state || {}, _ref3$requestLimit = _ref3.requestLimit, requestLimit = _ref3$requestLimit === undefined ? 1000 : _ref3$requestLimit;

            console.log("No product data found");
            allProductCount = window.bvaccel.collection.count;
            pageCount = (0, _Helpers.getPageCount)(allProductCount, requestLimit);
            ajaxUrls = getAjaxUrls(pageCount, window.bvaccel.collection.handle);


            console.log("Fetching " + pageCount + " page(s)... " + allProductCount + " products");

            return _context2.abrupt("return", _promise2.default.all(ajaxUrls.map(function (url) {
              return fetch(url).then(function (res) {
                return res.json();
              });
            })).then(function (responses) {
              console.log("Fetch complete");
              var data = (0, _Helpers.flattenMultidimensionalArray)(responses);
              setLocalForageValue(productCache, data);
              _jsCookie2.default.set(activeProductCache, true, { expires: .041, path: "/" });
              return data;
            }).catch(function (error) {
              console.log("Product request error", error);
            }));

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getAllProductsData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var getAjaxUrls = function getAjaxUrls(pageCount) {
  var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "all";

  return [].concat((0, _toConsumableArray3.default)(Array(pageCount).keys())).map(function (index) {
    var index1 = index + 1;
    console.log("[" + index1 + "] URL: /collections/" + handle + "?view=ajax-json&page=" + index1);
    return "/collections/" + handle + "?view=ajax-json&page=" + index1;
  });
};

var renderGridItem = exports.renderGridItem = function renderGridItem(item) {
  var imageSrc = item.image.src ? item.image.src : "//cdn.shopify.com/s/files/1/0043/8036/0773/t/6/assets/product-default_400x.jpg?102854";
  var imageSrcset = item.image.src2x ? item.image.src2x : "//cdn.shopify.com/s/files/1/0043/8036/0773/t/6/assets/product-default_400x@2x.jpg?102854";
  var alt = item.image.alt ? item.image.alt : "product image not found";
  var comparePrice = item.compare_at_price > item.price ? "<s>" + (0, _Helpers.formatMoney)(item.compare_at_price, true) + "</s>" : "";
  var soldOut = item.available ? "" : "<span class=\"product-grid__soldout\">Out of stock</span><span class=\"soldout-icon\"></span>";

  return "\n  <div data-ref=\"item\" class=\"product-grid__item grid__item small--one-half medium--one-half large--one-quarter\">\n    <a class=\"grid__image\" href=\"" + item.url + "\">\n      <img src=\"" + imageSrc + "\" srcset=\"" + imageSrcset + "\" alt=\"" + alt + "\">\n    </a>\n    <div class=\"text-container\">\n      <h4 class=\"product-grid__vendor\">" + item.vendor + "</h4>\n      <h3 class=\"product-grid__title\">\n       <a href=\"" + item.url + "\">" + item.title + "</a>\n      </h3>\n\n      <p class=\"product-grid__price\">\n        " + (0, _Helpers.formatMoney)(item.price, true) + "\n        " + comparePrice + "\n        " + soldOut + "\n      </p>\n    </div>\n    <div class=\"quick-view\">\n      <button data-product-handle=\"" + item.handle + "\">Quick View</button>\n    </div>\n  </div>\n  ";
};

var getLocalForageValue = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(key) {
    var storedCollection;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            storedCollection = sessionStorage.getItem(key) || false;
            return _context3.abrupt("return", storedCollection !== false ? JSON.parse(storedCollection) : storedCollection);

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function getLocalForageValue(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var setLocalForageValue = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(key, value) {
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            sessionStorage.setItem(key, (0, _stringify2.default)(value));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function setLocalForageValue(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();